import type {
  LoginSocialBarProperties,
  StyleProperties,
  CarmiCss,
} from '../../LoginSocialBar.types';
import { getFixedCSSVars } from './utils';

type GetOldCSSMapperOutputOptions = {
  compProps: LoginSocialBarProperties;
  styleProperties: StyleProperties;
  carmiCss: CarmiCss;
};

export const getOldCssMapperOutput = ({
  compProps,
  styleProperties,
  carmiCss,
}: GetOldCSSMapperOutputOptions) => {
  const loggedOutIconSize = compProps.loggedOutIconSize
    ? `${compProps.loggedOutIconSize}px`
    : carmiCss['--icon-size'];

  return {
    ...carmiCss,
    ...(compProps.arrowSize && {
      '--arrow-size': `${compProps.arrowSize}px`,
    }),
    '--logged-out-icon-size': loggedOutIconSize,
    ...getFixedCSSVars(styleProperties),
  };
};
